import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoinbaseComponent } from './simple-icons-coinbase.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoinbaseComponent ],
    exports:      [ SimpleIconsCoinbaseComponent ],
    bootstrap:    []
})
export class SimpleIconsCoinbaseModule {}
